import { getConfiguratorPriceV2 } from '../../utils/getConfiguratorPriceV2'
import type { ConfiguratorV2Line } from './SvgPreview'

export function useConfiguratorPriceInfo(lines: ConfiguratorV2Line[], scale: number) {
	return getConfiguratorPriceV2(lines, scale)
}
